import { Alert, AlertTitle, List, ListItem, Text } from '@shared/components';

import { type UseUserDetailsFormSubmissionError } from '../../types';

interface UserUpdateErrorsAlertProps {
  errors: UseUserDetailsFormSubmissionError[];
}

const ERROR_MESSAGE = {
  USER_PROFILE: 'ข้อมูลส่วนตัว',
  USER_APP_ROLES: 'บทบาทผู้ใช้ในระบบ',
  USER_STATUS: 'สถานะผู้ใช้',
};

export default function UserUpdateErrorsAlert(props: Readonly<UserUpdateErrorsAlertProps>) {
  const { errors } = props;

  if (errors.length === 0) {
    return null;
  }

  // NOTE: This checks if all errors are all in the key of ERROR_MESSAGE
  const allErrorsAreKnown = errors.every((error) => error.type in ERROR_MESSAGE);

  if (!allErrorsAreKnown) {
    return <Alert severity='error'>เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง</Alert>;
  }

  return (
    <Alert
      severity='error'
      sx={{
        alignItems: 'flex-start',
        '& .MuiAlert-message': {
          overflow: 'unset',
        },
      }}
    >
      <AlertTitle>ไม่สามารถอัปเดต User Details ได้</AlertTitle>
      <Text variant='body2'>กรุณาตรวจสอบและแก้ไขข้อมูลต่อไปนี้:</Text>
      <List
        sx={{
          listStyle: 'disc',
          display: 'flex',
          flexDirection: 'column',
          p: (theme) => theme.spacing(0, 0, 0, 6),
        }}
      >
        {errors.map((error) => {
          return (
            <ListItem
              key={error.type}
              sx={(theme) => ({
                display: 'list-item',
                p: theme.spacing(0),
                ...theme.typography.body2,
              })}
            >
              {ERROR_MESSAGE[error.type]}
            </ListItem>
          );
        })}
      </List>
    </Alert>
  );
}
